import Appsignal from "@appsignal/javascript";
import { ErrorBoundary } from "@appsignal/react";

// Get AppSignal instance from instrumentation-client.ts (initialized before hydration)
// Falls back to null on server or if not initialized
const appsignal =
  typeof window !== "undefined"
    ? ((window as unknown as { __appsignal?: Appsignal }).__appsignal ?? null)
    : null;

export default function AppsignalProvider({
  children,
  siteId,
}: {
  children: React.ReactNode;
  siteId?: string;
}) {
  if (!appsignal) {
    return <>{children}</>;
  }

  return (
    <ErrorBoundary instance={appsignal} tags={{ siteId: siteId || "unknown" }}>
      {children}
    </ErrorBoundary>
  );
}
